import React from 'react';

const Ready = (props) => {
 
  return (<div>준비중 입니다.</div>);
};

export default Ready;